<template>
  <div v-if="imageData?.length" ref="galleryModal" class="gm" aria-modal="true" role="dialog" aria-hidden="true" v-focus-trap="isOpen">
    <div class="gm__closeBtn" @click="handleCloseModal" @keydown="handleKeydownOnClose" role="button" tabindex="0" aria-label="Close button"></div>
    <div ref="imageSlider" class="gm__items-wrapper swiper-container">
      <div class="gm__items">
        <div v-for="(image,index) in  imageData" :key="index" class="gm__item">
          <ImageField 
            :key="image"
            class="gm__image"
            :obj="{'url':image,'alt':`Carousel Image ${index}`,'width':1292,'height':2000}" 
            fit="contain"
          /> 
        </div>
      </div> 
      <div class="gm__nav gm__prev">
        <svg class="gm__prev-icon">
          <use xlink:href="#icon-prev"></use>
        </svg>
      </div>
      <div class="gm__nav gm__next">
        <svg class="gm__next-icon">
          <use xlink:href="#icon-next"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted,computed } from 'vue';
  import ImageField from '../global/image.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';

  SwiperCore.use([Navigation, A11y]);

  onMounted(() =>{
    new Swiper(imageSlider.value, imageCarousel.value);

    if(imageData.value?.length){
      document.querySelectorAll('.data-gallery-image').forEach((image) => {
        image.setAttribute('aria-roledescription', 'This clickable image opens a fullscreen gallery for better viewing.');

        image.addEventListener('click',() => {
          handleOpenModal()
        })

        image.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOpenModal()
          }
        });
      })
    }
  })

  var galleryModal = ref(null)
  var imageSlider = ref(null)
  var imageData = ref(window.galleryImageData);
  var isOpen = ref(false);

const imageCarousel = computed(() => {
  return {
    slidesPerView: 1,
    wrapperClass: 'gm__items',
    slideClass: 'gm__item',
    navigation: {
      nextEl: '.gm__next',
      prevEl: '.gm__prev',
    },
    on: {
      init: sw => {
        document.querySelectorAll('.data-gallery-image').forEach((image, index) => {
          image.addEventListener('click', () => {
            sw.slideTo(index)
          })
        })
      },
    },
    a11y: {
      enabled: true
    }
  }
});

const handleOpenModal = () => {
  galleryModal.value.classList.add('is--open')
  galleryModal.value.setAttribute('aria-hidden', false)
  isOpen.value = true;
};

const handleCloseModal = () => {
  galleryModal.value.classList.remove('is--open')
  galleryModal.value.setAttribute('aria-hidden', true)
  isOpen.value = false
};

const handleKeydownOnClose = (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    handleCloseModal()
  }
};
</script>